import * as React from "react";
const SvgBatchAdd24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 24,
        fill: "black",
        viewBox: "0 0 25 24"
      },
      props
    ),
    React.createElement("path", {
      fill: "#000",
      fillRule: "evenodd",
      d: "M24.5 6.5a5.986 5.986 0 0 1-2.087 4.548l1.017.551h.008v1.773h-.003l.005.01-2.149 1.166 2.139 1.16h.008v1.772h-.003l.005.01-10.929 5.933-.004-.007-.004.007L1.505 17.49H1.5v-1.773h.008l2.157-1.17-2.16-1.165H1.5V11.61h.008l1.96-1.063-1.92-1.043h-.015V7.448l-.004-.008 10.928-5.933.005.009.009-.016 1.651.897A6 6 0 0 1 24.5 6.5Zm-6 6c-.194 0-.386-.01-.576-.027l-5.45 2.959-.004-.008-.004.008-6.901-3.747-1.493.81 8.432 4.549 8.38-4.55-.529-.286a5.995 5.995 0 0 1-1.855.292Zm-6-6c0-.865.183-1.687.512-2.43l-.542-.295-8.64 4.692 8.64 4.691 2.869-1.557A5.996 5.996 0 0 1 12.5 6.5Zm6.695 9.187-6.684 3.628-.004-.007-.004.007-6.734-3.633-1.697.92 8.432 4.55 8.38-4.55-1.69-.915ZM17.75 2.75v3h-3v1.5h3v3h1.5v-3h3v-1.5h-3v-3h-1.5Z",
      clipRule: "evenodd"
    })
  );
export default SvgBatchAdd24Px;
